module.exports = __webpack_public_path__ + "img/NNE.937bd854.svg";